import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import type { AchievementType } from '~/types/unified-profile'

export default class UnifiedProfileAchievement extends BaseModel {
  static override constructorName = 'UnifiedProfileAchievementModel'

  type: AchievementType = 'publications'
  'conference_name': string | null = null
  'start_of_conference': string | null = null
  'end_of_conference': string | null = null
  'conference_link': string | null = null
  'conference_status_id': number | null = null
  'conference_status': string | null = null
  'publication_name': string | null = null
  'publication_date': string | null = null
  'publication_link': string | null = null
  'grant_name': string | null = null
  'start_of_payment': string | null = null
  'end_of_payment': string | null = null
  'competition_name': string | null = null
  achievements: string | null = null
  'course_name': string | null = null
  company: string | null = null
  'start_of_teaching': string | null = null
  'end_of_teaching': string | null = null

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(UnifiedProfileAchievement)
